import { Loading } from "../models/model";
import { LoadingActions } from "../interface/reducerType";

const initialState = {
  isLoadingBack: false,
  isAgentLoading: false,
  initialLoading: false,
  loadingText: "",
  workStatus: "",
  isgetContact: false,
  allContactList: [],
  sideBarOverlaySettings: false,
  Menucollapse: true,
  settingsMenuValue: "",
  forceCloseSideBarOverLaySettings: false,
  sideBarOverlayContacts: false,
  sideBarOverlayReports:false,
  contactsMenuValue: "",
  forceCloseSideBarOverLayContacts: false,
  mainValue: "",
  notificationList: [],
};
export const commonReducer = (
  state: Loading = initialState,
  action: LoadingActions
) => {
  switch (action.type) {
    case "LOGIN_LOADING":
      return { ...state, isLoadingBack: action.payload.isLoadingBack };
    case "AGENT_LOADING":
      return { ...state, isAgentLoading: action.payload.isAgentLoading };
    case "INITIAL_LOADING":
      return {
        ...state,
        initialLoading: action.payload.initialLoading,
        loadingText: action.payload.loadingText,
      };
    case "WORKING_STATUS":
      return { ...state, workStatus: action.payload.workStatus };
    case "GET_CONTACT_LIST":
      return {
        ...state,
        isgetContact: action.payload.isgetContact,
        allContactList: action.payload.allContactList,
      };
    case "SIDE_BAR_OVERLAY_SETTINGS":
      return {
        ...state,
        sideBarOverlaySettings: action.payload.sideBarOverlaySettings,
      };
    case "SIDE_BAR_OVERLAY_CONTACTS":
      return {
        ...state,
        sideBarOverlayContacts: action.payload.sideBarOverlayContacts,
      };

    case "SIDE_BAR_OVERLAY_REPORTS":
      return {
        ...state,
        sideBarOverlayReports: action.payload.sideBarOverlayReports,
      };
    case "SIDE_BAR_OVERLAY_COLLAPSE":
      return { ...state, Menucollapse: action.payload.Menucollapse };
    case "SETTING_MENU":
      return { ...state, settingsMenuValue: action.payload.settingsMenuValue };
    case "CONTACTS_MENU":
      return { ...state, contactsMenuValue: action.payload.contactsMenuValue };
    case "SIDE_BAR_OVERLAY_CLOSE_SETTINGS":
      return {
        ...state,
        forceCloseSideBarOverLaySettings:
          action.payload.forceCloseSideBarOverLaySettings,
      };
    case "SIDE_BAR_OVERLAY_CLOSE_CONTACTS":
      return {
        ...state,
        forceCloseSideBarOverLayContacts:
          action.payload.forceCloseSideBarOverLayContacts,
      };
    case "LEFT_MENU_VALUES":
      return { ...state, mainValue: action.payload.mainValue };
    case "NOTIFICATION":
      return { ...state, notificationList: action.payload.notificationList };
    default:
      return state;
  }
};
